import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import Paper from "@mui/material/Paper";
import { Box } from "@mui/material";
import IconButton from "@mui/material/IconButton";
import TripOriginIcon from "@mui/icons-material/TripOrigin";
import InputBase from "@mui/material/InputBase";
import CloseIcon from "@mui/icons-material/Close";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import TramIcon from "@mui/icons-material/Tram";
import DirectionsWalkIcon from "@mui/icons-material/DirectionsWalk";
import DirectionsBusIcon from "@mui/icons-material/DirectionsBus";
import { styled } from "@mui/material/styles";
import TurnRightIcon from "@mui/icons-material/TurnRight";
import Divider from "@mui/material/Divider";
import React, { memo, useEffect, useState } from "react";
import { useStoreDollHouseMap } from "../store";
import { shallow } from "zustand/shallow";
import { resetAllMapPathSvg } from "../components/customEvents.js";
import { useTheme, createTheme } from "@mui/material/styles";
import SvgBuscon from "./bus-icon";
import SvgTramIcon from "./tram-Icon";
import { __mobileHideBar } from "./SideBar";
import Autocomplete from "@mui/material/Autocomplete";
import $ from "jquery";
import { ClickAwayListener } from "@mui/base";

import {
  ARIA,
  VDARA,
  BELLAGIO,
  PARK_MGM,
  THE_COSMOPOLITAN,
  DISTRICT_HIGHLIGHTS,
  NOMAD,
  DOLBY,
  TMOBILE,
} from "../scripts/core/constants";
const Item = styled(Paper)(({ theme }) => ({
  background: "#191919 0% 0% no-repeat padding-box",
  ...theme.typography.body2,
  padding: theme.spacing(2),
  height: "270px",
  border: "1px solid #393939",
  borderRadius: 16,
  color: "#ffffff",
}));

const options = [
  ARIA,
  VDARA,
  BELLAGIO,
  PARK_MGM,
  THE_COSMOPOLITAN,
  NOMAD,
  DOLBY,
  TMOBILE,
];

function RouteForm({ mapAreaselection, handleRouteFormDollhousemapselection }) {
  const theme = useTheme();
  const _customTheme = createTheme({
    breakpoints: {
      values: {
        xs: 0,
        sm: 600,
        md: 1000,
        lg: 1200,
        xl: 1536,
      },
    },
  });
  const [busIcon, setBusIcon] = React.useState(false);
  const [allIcon, setAllIcon] = React.useState(false);
  const [walkIcon, setWalkIcon] = React.useState(false);
  const [tramIcon, setTramIcon] = React.useState(false);
  const [inputSourceValue, setinputSourceValue] = useState("");
  const [opensourceInput, setsourcopenInputValue] = useState(true);
  const [inputDestinationValue, setinputDestinationValue] = useState("");
  const [opendestInput, setsourcdestInputValue] = useState(true);

  const [sourcereset, setSourceReset] = useState(false);
  const [destreset, setDestReset] = useState(false);

  const dollhouseStore = useStoreDollHouseMap(
    (state) => ({
      setSourceAreaSelected: state.setSourceAreaSelected,
      setDestinationAreaSelected: state.setDestinationAreaSelected,
      sourceAreaSelected: state.sourceAreaSelected,
      destinationAreaSelected: state.destinationAreaSelected,
      setsubmitFindRoute: state.setsubmitFindRoute,
      setRouteTypeSelected: state.setRouteTypeSelected,
      removeDestinationPoiSelected: state.removeDestinationPoiSelected,
      removeSourcePoiSelected: state.removeSourcePoiSelected,
      updateMapAreaSelection: state.updateMapAreaSelection,
      updateSvgRoutePathVisibility: state.updateSvgRoutePathVisibility,
      routeTypeSelected: state.routeTypeSelected,
      changePopupvisibility: state.changePopupvisibility,
      changeAriaMapLevel: state.changeAriaMapLevel,
    }),
    shallow
  );

  const __routeIconHighlight = (all, bus, walk, tram) => {
    setAllIcon(all);
    setBusIcon(bus);
    setWalkIcon(walk);
    setTramIcon(tram);
  };

  useEffect(() => {
    if (dollhouseStore.routeTypeSelected === "all") {
      __routeIconHighlight(true, false, false, false);
    }
  }, [dollhouseStore.routeTypeSelected]);

  useEffect(() => {
    __routeIconHighlight(true, false, false, false);
    dollhouseStore.setRouteTypeSelected("all");
  }, []);

  const submitForm = () => {
    if (
      dollhouseStore.sourceAreaSelected !== "" &&
      dollhouseStore.destinationAreaSelected !== ""
    ) {
      //check map is in isometric view
      if (mapAreaselection === "") {
        handleRouteFormDollhousemapselection(dollhouseStore.sourceAreaSelected);
      }
      dollhouseStore.setsubmitFindRoute(true);
      dollhouseStore.changeAriaMapLevel("area_level_1");
      __mobileHideBar();
    }
  };

  useEffect(() => {
    setinputSourceValue(dollhouseStore.sourceAreaSelected);
    setsourcopenInputValue(false);
  }, [dollhouseStore.sourceAreaSelected]);

  useEffect(() => {
    setinputDestinationValue(dollhouseStore.destinationAreaSelected);
    setsourcdestInputValue(false);
  }, [dollhouseStore.destinationAreaSelected]);

  const handleOutsideClickEvent = () => {
    setsourcopenInputValue(false);
    setsourcdestInputValue(false);
  };
  useEffect(() => {
    window.addEventListener("click", handleOutsideClickEvent, false);

    return () => {
      window.removeEventListener("click", handleOutsideClickEvent, false);
    };
  }, []);

  return (
    <Stack
      sx={{
        margin: "20px 20px 10px",
        textAlign: "left",
        [_customTheme.breakpoints.down("md")]: {
          position: "absolute",
          width: "260px",
          left: "255px",
          top: "10px",
          margin: "0 0 0 10px",
        },
      }}
    >
      <Item
        sx={{
          [_customTheme.breakpoints.down("md")]: {
            borderRadius: 6,
          },
        }}
      >
        <Typography
          textAlign={"left"}
          sx={{
            // fontSize: 14,
            letterSpacing: 0,
            color: "#BDA770",
            font: "normal normal bold 14px/16px 'Trade Gothic LT Std',sans-serif",
            fontWeight: "bold",
          }}
          gutterBottom
        >
          Find Route
        </Typography>
        <Typography
          variant="body2"
          sx={{
            color: "#FFFFFF",
            // fontSize: 12,
            font: "normal normal normal 13px/20px 'Trade Gothic LT Std', sans-serif",
            letterSpacing: 0,
            // fontFamily: "'Trade Gothic LT Std', sans-serif",
            fontWeight: "initial",
          }}
        >
          Select two resorts from menu to find the routes.
        </Typography>
        <Box component="div" sx={{ padding: "20px 0" }}>
          <Paper
            component="form"
            sx={{
              p: "0",
              display: "flex",
              alignItems: "center",
              width: "auto",
              background: "transparent",
              boxShadow: "none",
            }}
          >
            <IconButton
              type="button"
              sx={{
                p: "0px",
                color: "#BDA770",
                width: "16px",
                height: "16px",
              }}
              aria-label="search"
            >
              <TripOriginIcon sx={{ width: "14px", height: "14px" }} />
            </IconButton>

            <Autocomplete
              ListboxProps={{
                sx: {
                  // fontSize: 2,
                  font: "normal normal bold 12px/13px 'Trade Gothic LT Std', sans-serif",
                },
              }}
              inputValue={inputSourceValue}
              autoFocus={false}
              onChange={(e, val) => {
                setinputSourceValue(val);
                setsourcopenInputValue(false);
                dollhouseStore.setSourceAreaSelected(val);
                setSourceReset(true);
              }}
              key={sourcereset}
              options={options}
              renderInput={(params) => (
                <div ref={params.InputProps.ref}>
                  <InputBase
                    {...params}
                    sx={{
                      ml: 1,
                      flex: 1,
                      color: "#fff",
                      padding: 0,
                      font: "normal normal normal 14px/20px 'Trade Gothic LT Std', sans-serif",
                      letterSpacing: 0,
                    }}
                    inputProps={{
                      ...params.inputProps,
                      onKeyDown: (e) => {
                        if (e.key === "Enter") {
                          e.preventDefault();
                        }
                      },
                    }}
                    onChange={(e) => {
                      setinputSourceValue(e.target.value);
                      if (!opensourceInput) {
                        setsourcopenInputValue(true);
                      }
                    }}
                    placeholder="Type First Resort"
                  />
                </div>
              )}
              open={opensourceInput && inputSourceValue.length > 0}
            />

            {dollhouseStore.sourceAreaSelected && (
              <IconButton
                type="button"
                sx={{ p: "0" }}
                aria-label="clear origin"
                onClick={() => {
                  dollhouseStore.setSourceAreaSelected("");

                  __routeIconHighlight(true, false, false, false);
                  dollhouseStore.setRouteTypeSelected("all");
                  resetAllMapPathSvg();
                  dollhouseStore.updateSvgRoutePathVisibility(false);
                  dollhouseStore.removeSourcePoiSelected();

                  setinputSourceValue("");
                  setSourceReset(false);
                }}
              >
                <CloseIcon sx={{ color: "#b59442", width: "0.8em" }} />
              </IconButton>
            )}
          </Paper>
          <Divider
            sx={{
              height: 32,
              marginLeft: "7px",
              paddingTop: 1,
              width: 0,
              border: "none",
              borderLeft: "2px dashed #FFFFFF3C",
            }}
            orientation="vertical"
          />
          <Paper
            component="form"
            sx={{
              p: "0",
              display: "flex",
              alignItems: "center",
              width: "auto",
              background: "transparent",
              boxShadow: "none",
            }}
          >
            <IconButton
              type="button"
              sx={{
                p: "0px",
                color: "#BDA770",
                width: "16px",
                height: "16px",
              }}
              aria-label="search"
            >
              <LocationOnIcon sx={{ width: "14px", height: "14px" }} />
            </IconButton>

            <Autocomplete
              ListboxProps={{
                sx: {
                  fontSize: 11,
                  font: "normal normal normal 14px/20px 'Trade Gothic LT Std', sans-serif",
                },
              }}
              inputValue={inputDestinationValue}
              key={destreset}
              onChange={(e, val) => {
                if (dollhouseStore.sourceAreaSelected === val) {
                  return false;
                }

                setinputDestinationValue(val);
                setsourcdestInputValue(false);
                dollhouseStore.setDestinationAreaSelected(val);
                setDestReset(true);
              }}
              options={options}
              renderInput={(params) => (
                <div ref={params.InputProps.ref}>
                  {/* <input type="text" {...params.inputProps}  /> */}
                  <InputBase
                    {...params}
                    sx={{
                      ml: 1,
                      flex: 1,
                      color: "#fff",
                      padding: 0,
                      font: "normal normal normal 14px/20px 'Trade Gothic LT Std', sans-serif",
                      letterSpacing: 0,
                    }}
                    onChange={(e) => {
                      setinputDestinationValue(e.target.value);
                      if (!opendestInput) {
                        setsourcdestInputValue(true);
                      }
                    }}
                    inputProps={{
                      ...params.inputProps,
                      onKeyDown: (e) => {
                        if (e.key === "Enter") {
                          e.preventDefault();
                        }
                      },
                    }}
                    placeholder="Type Second Resort"
                  />
                </div>
              )}
              open={opendestInput && inputDestinationValue.length > 0}
            />

            {dollhouseStore.destinationAreaSelected && (
              <IconButton
                type="button"
                sx={{ p: "0" }}
                aria-label="clear destination"
                onClick={() => {
                  dollhouseStore.setDestinationAreaSelected("");

                  __routeIconHighlight(true, false, false, false);
                  dollhouseStore.setRouteTypeSelected("all");

                  // setdestValue("");
                  // setdestinationValue("");
                  // setMapRouteHotspot({
                  //     selected: "",
                  //     source: origValue,
                  //     destination: "",
                  // });
                  resetAllMapPathSvg();
                  dollhouseStore.updateSvgRoutePathVisibility(false);
                  setinputDestinationValue("");
                  setDestReset(false);
                  // // resetSelectedHotspot(destinationValueKey);
                  // // console.log("clear destination----");
                  dollhouseStore.removeDestinationPoiSelected();
                }}
              >
                <CloseIcon sx={{ color: "#b59442", width: "0.8em" }} />
              </IconButton>
            )}
          </Paper>
        </Box>

        <Stack
          direction="row"
          spacing={1}
          sx={{
            justifyContent: "space-between",
            paddingTop: "6px",
            "& .MuiButtonBase-root": { margin: 0 },
          }}
        >
          <Box>
            <IconButton
              variant="contained"
              sx={{
                background: "#101010",
                color: "#FFFFFF",
                fontSize: "11px",
                width: "32px",
                height: "34px",
                padding: 0,
                border: allIcon ? "solid 1px #fff" : "none",
                borderRadius: "6px",
                font: "normal normal normal 14px/20px 'Trade Gothic LT Std', sans-serif",
                fontWeight: "initial",
                "& .MuiButtonBase-root": {
                  padding: 6,
                },
                "&:hover": {
                  backgroundColor: "#b59442",
                },
              }}
              onClick={() => {
                // if (originValue === "" || destinationValue === "") {
                //     // console.log(originValue, destinationValue);
                //     return;
                // }
                __routeIconHighlight(true, false, false, false);
                dollhouseStore.setRouteTypeSelected("all");
                submitForm();

                // changeNavigationPathtype("all");
                // setRoutePath("all");
              }}
            >
              All
            </IconButton>

            {/* <IconButton
              aria-label="bus"
              className="bus-svg"
              sx={{
                padding: " 6px 0px 0 0",
                border: busIcon ? "solid 1px #fff" : "none",
                borderRadius: "6px",
                margin: "0 5px !important",
              }}
              onClick={() => {
                // if (originValue === "" || destinationValue === "") {
                // // console.log(originValue, destinationValue);
                // return;
                // }
                __routeIconHighlight(false, true, false, false);
                dollhouseStore.setRouteTypeSelected("bus");
                submitForm();

                // setRoutePath("bus");
                // setShow(false);

                // changeNavigationPathtype("bus");

                // routesType('bus'); setShow(false)
              }}
            > */}
            {/* <DirectionsBusIcon
                sx={{
                  color: busIcon ? "#ffffff" : "#5b5b5b",
                  fontSize: "1.3rem",
                  borderRadius: "6px",
                  "&:hover": {
                    color: "#BDA770",
                  },
                }}
              /> */}
            {/* <SvgBuscon
                sx={{
                  color: busIcon ? "#ffffff" : "#5b5b5b",
                  fontSize: "1.0rem",
                  borderRadius: "6px",
                  "&:hover": {
                    color: "#BDA770",
                  },
                }}
              />
            </IconButton> */}
            <IconButton
              aria-label="train"
              className="tram-svg"
              sx={{
                padding: " 6px 0px 0 0",
                border: tramIcon ? "solid 1px #fff" : "none",
                borderRadius: "6px",
                margin: "0px 15px 0px 25px!important",
              }}
              onClick={() => {
                // if (originValue === "" || destinationValue === "") {
                // return;
                // }
                __routeIconHighlight(false, false, false, true);
                dollhouseStore.setRouteTypeSelected("train");
                submitForm();

                // setRoutePath("tram");
                // setShow(false);
                // changeNavigationPathtype("tram");

                // routesType('train'); setShow(false)
              }}
            >
              {/* <TramIcon
                sx={{
                  color: tramIcon ? "#ffffff" : "#5b5b5b",
                  fontSize: "1.3rem",
                  borderRadius: "6px",
                  "&:hover": {
                    color: "#BDA770",
                  },
                }}
              /> */}
              <SvgTramIcon
                sx={{
                  color: tramIcon ? "#ffffff" : "#5b5b5b",
                  fontSize: "1.3rem",
                  borderRadius: "6px",
                  "&:hover": {
                    color: "#BDA770",
                  },
                }}
              />
            </IconButton>
            <IconButton
              aria-label="walk"
              sx={{
                padding: " 6px 0px 0 0",
                border: walkIcon ? "solid 1px #fff" : "none",
                borderRadius: "6px",
                margin: "0 5px !important",
              }}
              onClick={() => {
                // if (originValue === "" || destinationValue === "") {
                // return;
                // }
                __routeIconHighlight(false, false, true, false);
                dollhouseStore.setRouteTypeSelected("walk");
                submitForm();
                // setRoutePath("walk");
                // setShow(false);
                // changeNavigationPathtype("walk");

                // routesType('walk'); setShow(false)
              }}
            >
              <DirectionsWalkIcon
                sx={{
                  color: walkIcon ? "#ffffff" : "#5b5b5b",
                  fontSize: "1.3rem",
                  borderRadius: "6px",
                  "&:hover": {
                    color: "#BDA770",
                  },
                }}
              />
            </IconButton>
          </Box>
          <IconButton
            aria-label="direction"
            sx={{
              // left: "6px",
              width: "47px",
              // marginLeft: "10px !important",
              background: "#BDA770",
              height: "34px",
              borderRadius: "6px",
              "&:hover": {
                color: "#b59442",
                backgroundColor: "#BDA770",
              },
            }}
            onClick={submitForm}
          >
            <TurnRightIcon
              sx={{
                color: "#FFFFFF",
                background: "#BDA770",
                "&:hover": {
                  backgroundColor: "#BDA770",
                },
              }}
            />
          </IconButton>
        </Stack>
      </Item>
    </Stack>
  );
}

export default memo(RouteForm);
